const zipCodePatternA = new RegExp('^[0-9]{5}$');
const zipCodePatternB = new RegExp('^[a-zA-Z][a-zA-Z0-9]{5}$');

export const checkValidZipCode = (zipCode: string) => {
  const trimmedZipCode = zipCode.trim();
  return (
    zipCodePatternA.test(trimmedZipCode) ||
    zipCodePatternB.test(trimmedZipCode.replace(/\s/g, ''))
  );
};

// The manual city/state flow has no validated address to read a country from —
// typing in the ZIP field clears it — so the postal-code shape is the only
// signal left. Letter-leading codes are Canadian. Five-digit codes are
// ambiguous between USA and MEX, so they fall back to USA and the user corrects
// it with the country selector.
export const deriveCountryFromZipCode = (zipCode: string): string =>
  zipCodePatternB.test(zipCode.trim().replace(/\s/g, '')) ? 'CAN' : 'USA';
